<template>
  <PhotoTile v-if="product" :product="product" :image-url="imageUrl" />
</template>

<script>
import PhotoTile from "@/components/PhotoTile.vue";
import productQuery from "@/graphql/queries/Product.gql";

export default {
  name: "AddFromPhoto",
  components: {
    PhotoTile,
  },
  props: {
    productHandle: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      product: null,
    };
  },
  apollo: {
    product: {
      query: productQuery,
      variables() {
        return {
          product: this.productHandle,
          selectedOptions: [],
        };
      },
    },
  },
};
</script>
